import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { GrnVehicleInspectionInfo } from '../dto/grn-vehicle.dto';
import { VehicleInspectionAdapter } from '../dto/vehicle-inspection-adapter';
import { Grn } from '../raw-material-grn.entity';
import { VehicleInspectionRepository } from '../vehicle-inspection.repository';
import { GrnRequest } from '../dto/raw-material-grn.request';
import { VehicleService } from '@gtpl/shared-services/masters';
import { VehicleRequest } from '@gtpl/shared-models/masters';
import { SuppliersService } from '@gtpl/shared-services/masters';
import { FarmerModel } from '@gtpl/shared-models/masters';
import { ProductService } from '@gtpl/shared-services/masters';
import { ProductRequest } from '@gtpl/shared-models/masters';
import { RMVehicleInfoResponse } from '@gtpl/shared-models/raw-material-procurement';
import { GrnVehicleInfo } from '@gtpl/shared-models/raw-material-procurement';
import { GrnItems } from '../raw-material-grn-items.entity';
import { RMGrnItemIdReq } from '../dto/grn-item-id.request';
@Injectable()
export class VehicleInspectionService {
    constructor(private repository: VehicleInspectionRepository,
        private adapter: VehicleInspectionAdapter,
        private vehicleService: VehicleService,
        private supplierService: SuppliersService,
        private productService: ProductService) { }

    async createVehicleInspectionInfo(inspectionInfo: GrnVehicleInspectionInfo): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            const today = new Date();
            const CurrentYear = today.getFullYear();
         
            let totalPO = await this.repository.count();
           

            totalPO = totalPO + 1;

            let refNo = totalPO + "";
            while (refNo.length < 4) refNo = "0" + refNo;

            inspectionInfo.rmVINumber = "RMVI" + (CurrentYear.toString().substr(-2)) + "/"+ refNo;
            await manager.startTransaction();
            const convertedEntity = await this.adapter.convertDtoToEntity(inspectionInfo);
            const savedInfo = await manager.getCustomRepository(VehicleInspectionRepository).save(convertedEntity);

            if (savedInfo) {
                //update grn vehicle inspection status
                const updateGrn = await manager.getRepository(GrnItems).update({ grnItemId: savedInfo.grnItemId }, { isVInspectionCompleted: true });
                if (updateGrn.affected) {
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'RM Vehicle Inspection Info Updated Successfully')
                } else {
                    throw new ErrorResponse(9999, 'Failed to update RM GRN');
                }
            } else {
                throw new ErrorResponse(9999, 'Failed to Create Details');
            }

        } catch (error) {
            manager.releaseTransaction();
            return error;
        }
    }


    async getVehicleInspectionInfo(req:RMGrnItemIdReq): Promise<CommonResponse>{
        const manager = new GenericTransactionManager();
        try{
            await manager.startTransaction();
            const inspecInfo = await manager.getCustomRepository(VehicleInspectionRepository).findOne({where: {grnItemId: req.grnItemId}});
            if(inspecInfo){
                const convertedInfo = await this.adapter.convertEntityToDto(inspecInfo);
                const req = new VehicleRequest(convertedInfo.vehicleId);                
                const vehicleData = await this.vehicleService.getVehicleByVehId(req);
                convertedInfo.vehicleNumber = vehicleData.data.registrationNumber; 

                const supplierReq = new FarmerModel(convertedInfo.supplierId);
                const supplierData = await this.supplierService.getSupplierBySupplierId(supplierReq);
                convertedInfo.supplierCode = supplierData.data.supplierCode;
                convertedInfo.supplierAddress = supplierData.data.address;

                const productReq = new ProductRequest(convertedInfo.productId);
                const productData = await this.productService.getActiveProductById(productReq);
                convertedInfo.varietyOfMaterial = productData.data.productName;

                // const response = new GrnVehicleInfo(convertedInfo.rmGrnId, convertedInfo.indentId, convertedInfo.supplierId, convertedInfo.vehicleId, convertedInfo.productId, convertedInfo.indentNumber, convertedInfo.rmVINumber, convertedInfo.)
               
                return new CommonResponse(true, 1111, 'Vehicle Inspeciton Info Obtained Successfully', convertedInfo)
            }else{
                throw new ErrorResponse(9999, 'Cannot find Info');
            }
        }catch(error){
            manager.releaseTransaction();
            return error;
        }
    }
}
